import React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { Button, Divider, Skeleton, Typography } from '@mui/material';
import styles from './ActivePatrolDrawer.module.css';
import ChecklistCard from '../checklistCard/ChecklistCard';
import ActivePatrolDrawerHeader from './ActivePatrolDrawerHeader';
import GeneralNotesComponent from '../generalNotesComponent/GeneralNotesComponent';
import PatrolAttachments from '../patrolAttachments/PatrolAttachments';
import LoadingBackdrop from 'components/LoadingBackdrop';
import PatrolUnsavedWarning from '../alertDialog/PatrolUnsavedWarning';
import PatrolIncompleteWarning from '../alertDialog/PatrolIncompleteWarning';
import { useActivePatrolUI } from '../../context/activePatrol/ActivePatrolUIProvider';
import { useActivePatrolData } from '../../context/activePatrol/ActivePatrolDataProvider';
import { useActivePatrolLogic } from '../../context/activePatrol/ActivePatrolLogicProvider';

interface ActivePatrolDrawerProps {}

const ActivePatrolDrawer: React.FC<ActivePatrolDrawerProps> = (props) => {
	const { showDrawer, showLoadingBackdrop, showDrawerSkeleton } =
		useActivePatrolUI();
	const { checklists } = useActivePatrolData();
	const { savePatrol, endPatrol } = useActivePatrolLogic();

	return (
		<Drawer
			anchor={'bottom'}
			open={showDrawer}
			sx={{
				'& .MuiDrawer-paperAnchorBottom': {
					height: '100%',
					backgroundImage: 'unset',
				},
			}}
		>
			<Box
				padding={2}
				sx={{
					width: '100%',
				}}
			>
				{!showDrawerSkeleton ? (
					<Box display={'flex'} flexDirection={'column'} gap={1}>
						<ActivePatrolDrawerHeader />
						<Divider className={styles.divider} />
						<Box>
							<Typography
								textAlign={'center'}
								variant="h5"
								className={styles.title}
							>
								Attachments
							</Typography>
							<Box
								display={'flex'}
								flexDirection={'column'}
								gap={2}
							>
								<PatrolAttachments />
							</Box>
						</Box>
						<Box>
							<Typography
								textAlign={'center'}
								variant="h5"
								className={styles.title}
							>
								Checklists
							</Typography>
							<Box
								display={'flex'}
								flexDirection={'column'}
								gap={2}
							>
								{checklists.length === 0 && (
									<Typography
										textAlign={'center'}
										variant="body1"
										color={'warning.main'}
										fontStyle={'italic'}
									>
										No checklists available
									</Typography>
								)}
								{checklists.map((checklist, index) => (
									<ChecklistCard
										key={index}
										checklist={checklist}
									/>
								))}
							</Box>
						</Box>
						<Box>
							<Typography
								textAlign={'center'}
								variant="h5"
								className={styles.title}
							>
								General Notes
							</Typography>
							<GeneralNotesComponent />
						</Box>
						<Box display={'flex'} justifyContent={'center'} gap={2}>
							<Button
								variant="outlined"
								onClick={() => savePatrol(() => {})}
							>
								Save
							</Button>
							<Button
								variant="outlined"
								onClick={() => endPatrol()}
								color="error"
							>
								End
							</Button>
							{/* <Button variant="outlined">Save & End</Button> */}
						</Box>
					</Box>
				) : (
					<>
						<Skeleton />
						<Skeleton animation="wave" />
						<Skeleton animation={false} />
					</>
				)}
			</Box>
			<PatrolUnsavedWarning />
			<PatrolIncompleteWarning />
			<LoadingBackdrop open={showLoadingBackdrop} />
		</Drawer>
	);
};

export default ActivePatrolDrawer;
